<template>
    <div>
        <!-- 查询 -->
        <!-- <div class="searchPanel">
            <SearchForm 
                :class="{queryForm_en:lang == 'en', queryForm_zh:lang == 'zh'}" 
                :form="queryForm"
                @handleInputChange="handleInputChange"
                @handleSelectChange="handleQuerySelectChange"
                @handlePressEnter="handleQueryPressEnter"
            ></SearchForm>
        </div> -->
        <div class="app_id">
            关联的小程序：
            <a-select 
                v-model:value="app_id" 
                placeholder="请选择小程序" 
                style="width: 200px;" 
                :options="appOptions" 
                @change="handleChangeAppId"
            ></a-select>
        </div>
        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="primary" size="small" class="operate_btn" @click="handle('export', props.record)">
                        <component :is="$antIcons['ExportOutlined']"></component>
                        {{$t('base.export')}}
                    </a-button> 
                </template>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from 'vue';
    // import SearchForm from '@/components/SearchForm.vue';
    import Table from '@/components/Table.vue';
    import { useI18n } from 'vue-i18n';
    import { useRouter } from 'vue-router';
    import { message, Modal } from 'ant-design-vue';
    import { CustomerApi } from '@/api/CustomerApi.js';
    import { SmallProgramApi } from '@/api/SmallProgramApi.js';

    const { t } = useI18n()
    const router = useRouter()
    


    const app_id = ref('')
    const appOptions = ref([])
    const table = ref({
        data: [],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('customer.customer_name'),//'客户名称'
                dataIndex: 'dict_name',
                key: 'dict_name',
                resizable: true,
                locel:'user.dict_name',
            },
            {
                title: t('customer.remark'),//'备注'
                dataIndex: 'remark',
                key: 'remark',
                resizable: true,
                locel:'user.remark',
            },
            {
                title: t('customer.create_time'),//'创建时间'
                dataIndex: 'create_time',
                key: 'create_time',
                resizable: true,
                locel:'user.create_time',
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 120,
                resizable: true,
            },
        ],
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const handle = (type, row)=>{
        switch(type){
            case 'export':
                exportCustomer(row.id)
                break;
        }
    }

    const handleChangeAppId = (value)=>{
        app_id.value = value
        getList()
    }


    const getList = async ()=>{
        table.value.configs.loading = true
        let res = await CustomerApi.getInstance().getCustomerList(app_id.value)
        if(res.code == 0){
            res.data.forEach((i, index) => {
                i.serial = index + 1
                i.remark = !i.remark? '-' : i.remark
                i.create_time = i.create_time == undefined? '-' : i.create_time
            })
            table.value.data = res.data
            table.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }


    const exportCustomer = async (id)=>{
        let res = await CustomerApi.getInstance().exportCustomer(id)
        if(res){
            let blob = new Blob([res], { type: 'application/octet-stream' })
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = '客户配置数据.xlsx'
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            message.success('导出成功')
        }else{
            message.error(res.msg)
        }
    }


    // 获取用户小程序名称
    const getAppNameList = async ()=> {
        let param = {
            status:0,
        }
        let res = await SmallProgramApi.getInstance().getSmallProgramQuery(param)
        if (res.code == 0) {
            res.data.length > 0 && res.data.forEach(item=>{
                appOptions.value.push({
                    label: item.app_name,
                    value: item.app_id,
                })
            })
            console.log(appOptions.value,'appOptions.value')
            app_id.value = appOptions.value[0].value
        } else {
            message.error(res.msg);
        }
    } 


    onMounted(async ()=>{
        await getAppNameList()
        getList()
    })
</script>

<style lang="scss" scoped>

</style>